import { Box, CircularProgress } from "@mui/material";

export const CircularProgressIndicator = () => (
  <Box sx={{ display: "flex", justifyContent: "center" }}>
    <CircularProgress />
  </Box>
);
